import { useEffect } from "react";

// Aggiorna direttamente i tag <head> esistenti (quelli serviti dal server via
// scripts/seo-postbuild.js) invece di affidarsi all'hoisting di React 19,
// che su alcune pagine produce un <title> vuoto.
const SITE_URL = "https://casalisilvia.com";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!content) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export const applySEO = ({ title, description, keywords, ogImage, ogType, noindex }) => {
  const safeTitle = title || "SC Dottori Commercialisti";
  let path = window.location.pathname;
  if (path.length > 1 && path.endsWith("/")) path = path.slice(0, -1);
  const canonical = path === "/" ? SITE_URL : `${SITE_URL}${path}`;

  document.querySelectorAll("head > title").forEach((t, i) => { if (i > 0 || !t.textContent) t.remove(); });
  document.title = safeTitle;
  upsertMeta("name", "description", description || "");
  upsertMeta("name", "keywords", keywords || "");
  upsertMeta("name", "robots", noindex ? "noindex, follow" : "");

  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", canonical);

  upsertMeta("property", "og:title", safeTitle);
  upsertMeta("property", "og:description", description || "");
  upsertMeta("property", "og:type", ogType || "website");
  upsertMeta("property", "og:url", canonical);
  upsertMeta("property", "og:site_name", "SC Dottori Commercialisti");
  upsertMeta("property", "og:image", ogImage || "");
  upsertMeta("name", "twitter:card", ogImage ? "summary_large_image" : "");
  upsertMeta("name", "twitter:image", ogImage || "");
};

export const PageSEO = (props) => {
  useEffect(() => {
    applySEO(props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.title, props.description, props.keywords, props.ogImage, props.ogType, props.noindex]);
  return null;
};
